// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rP2j","title":"Header_title__3u3sV","side":"Header_side__3k4IL"};